import { MenuOutlined } from "@ant-design/icons";
import {
  Col,
  Flex,
  Row,
  Typography,
  Grid,
  MenuProps,
  Dropdown,
  Space,
} from "antd";
const { useBreakpoint } = Grid;

type RobinPageProps = {
  title?: string;
  actions?: { label: React.ReactNode; key?: React.Key }[];
  children?: React.ReactNode;
};

function RobinPage({ title, actions, children }: RobinPageProps) {
  const { lg, md } = useBreakpoint();
  const menuItems: MenuProps["items"] = actions?.map((rec, index) => ({
    label: rec.label,
    key: index + 1,
  }));
  const smallActions = (
    <Dropdown menu={{ items: menuItems }} trigger={["click"]}>
      <a onClick={(e) => e.preventDefault()}>
        <Space>
          <MenuOutlined />
        </Space>
      </a>
    </Dropdown>
  );

  const largeActions = actions?.map((rec, index) => (
    <span key={rec.key ?? index}>{rec.label}</span>
  ));

  return (
    <Row>
      <Col lg={12} md={12} sm={18} xs={18}>
        <Typography.Title level={lg || md ? 1 : 3}>{title}</Typography.Title>
      </Col>
      <Col span={12} md={12} sm={6} xs={6}>
        <Flex
          style={{ height: "100%" }}
          align="center"
          justify="flex-end"
          gap="large"
        >
          {(actions?.length || 0) > 1 && !md ? smallActions : largeActions}
        </Flex>
      </Col>
      <Col span={24}>{children}</Col>
    </Row>
  );
}

export default RobinPage;
